import React, {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { formatBytes } from '../Function';
import { Container,Card } from 'react-bootstrap';
import Slider from "react-slick";
import '../focusUtils';
const HpCenters = () => 
{
    const fileurl = global.config.uploadPath+'1804948305.pdf';
    const fileSize = formatBytes(2192478);
    const { t } = useTranslation();
    useEffect(()=>
    {
        window.disableFocusInHiddenSlides();
        window.enableFocusInVisibleSlides();   
    },[])
    const settings = {
        autoplay: true,
        centerMode: false,
        infinite: true,
        centerPadding: "0px",
        dots: true,
        slidesToShow: 4,
        speed: 500,
        accessibility: true,
        beforeChange: (current, next) => { window.disableFocusInHiddenSlides(); },
        afterChange: current => { window.enableFocusInVisibleSlides(); },
        responsive: [{ breakpoint: 1024,settings: { slidesToShow: 1 }} ]
    };
    return (
        <section className="hp-centers">
            <Container className="py-md-5 py-4 text-center">
                <h2 data-aos="flip-down" data-aos-duration="1500">{t('Centers')}</h2>
                <span className="mb-4 sub-heading" data-aos="flip-down" data-aos-duration="1500"></span>
                <div className="slider-container px-4 py-3" data-aos="fade-up" data-aos-duration="1500">
                    <Slider {...settings}>
                        <div className='p-3'>
                            <Card className='text-center card-custom'>
                                <Card.Img variant="top" className="img-fluid" src={global.config.uploadPath+'785990317.jpg'} width={260} height={160} alt={t('CEAMS_ALT')} loading="lazy" />
                                <Card.Body>
                                    <Card.Title className='fs-6 mb-0' dangerouslySetInnerHTML={{ __html: t('CEAMS') }} />
                                </Card.Body>
                                <Card.Footer className='text-bg-info'>
                                    <a href='https://sites.google.com/view/advanced-mechatronics/home' target="_blank" rel="noopener noreferrer" className='link-light'>
                                        {t('ReadMore')} <i className="bi bi-arrow-right-short"></i>
                                    </a>
                                </Card.Footer>
                            </Card>
                        </div>
                        <div className='p-3'>
                            <Card className='text-center card-custom'>
                                <Card.Img variant="top" className="img-fluid" src={global.config.uploadPath+'254067572.jpg'} width={260} height={160} alt={t('CEAI_ALT')} loading="lazy" />
                                <Card.Body>
                                    <Card.Title className='fs-6 mb-0' dangerouslySetInnerHTML={{ __html: t('CEAI') }} />
                                </Card.Body>
                                <Card.Footer className='text-bg-info'>                                
                                    <a href={fileurl} target="_blank" rel="noopener noreferrer" aria-label={t('OpensPdf')} className='link-light'>
                                        <i className="bi bi-filetype-pdf" aria-hidden="true"></i> PDF, {fileSize}
                                    </a>
                                </Card.Footer>
                            </Card>
                        </div>
                        <div className='p-3'>
                            <Card className='text-center card-custom'>
                                <Card.Img variant="top" className="img-fluid" src={global.config.uploadPath+'464586600.jpg'} width={260} height={160} alt={t('CSD_ALT')} loading="lazy" />
                                <Card.Body>
                                    <Card.Title className='fs-6 mb-0' dangerouslySetInnerHTML={{ __html: t('CSD') }} />
                                </Card.Body>
                                <Card.Footer className='text-bg-info'>
                                    <a href='https://csd.igdtuw.ac.in' target="_blank" rel="noopener noreferrer" className='link-light'>
                                        {t('ReadMore')} <i className="bi bi-arrow-right-short"></i>
                                    </a>
                                </Card.Footer>
                            </Card>
                        </div>
                        <div className='p-3'>
                            <Card className='text-center card-custom'>
                                <Card.Img variant="top" className="img-fluid" src={global.config.uploadPath+'1007928605.jpg'} width={260} height={160} alt={t('IIC_ALT')} loading="lazy" />
                                <Card.Body>
                                    <Card.Title className='fs-6 mb-0' dangerouslySetInnerHTML={{ __html: t('IIC') }} />
                                </Card.Body>
                                <Card.Footer className='text-bg-info'>
                                    <a href='https://www.anveshanfoundation.org/' target="_blank" rel="noopener noreferrer" className='link-light'>
                                        {t('ReadMore')} <i className="bi bi-arrow-right-short"></i>
                                    </a>
                                </Card.Footer>
                            </Card>
                        </div>
                    </Slider>
                </div>
            </Container>
        </section>
    );    
}
export default HpCenters;